import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import AuthLayout from "./layouts/Auth.js";
import AdminLayout from "./layouts/Admin.js";
import STView from "./views/cetak/STSurve";
import { isAuthenticated } from "./utils/authGuard";

function RequireAuth({ children }) {
  if (!isAuthenticated()) {
    return <Navigate to="/auth/signin" replace />;
  }
  return children;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Routes>
      {/* <Route path="/stsurve" element={<STView />} /> */}
      <Route path="/" element={<Navigate to="/auth/signin" replace />} />
      <Route path="/auth/*" element={<AuthLayout />} />
      <Route
        path="/admin/*"
        element={
          <RequireAuth>
            <AdminLayout />
          </RequireAuth>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </BrowserRouter>
);
